import React from 'react'
import { components } from 'react-select'

const TwoPartLabel = ({
  ...innerProps
}) => {
  const { data } = innerProps
  const label = data.label || data.value
  const isArray = Array.isArray(label)

  const mainLabel = isArray
    ? label[0]
    : label

  const subLabel = isArray && label.length > 1
    ? label.slice(1).join(', ')
    : undefined

  return (
    <components.SingleValue
      {...innerProps}
      className='vs-select-label'
    >
      {mainLabel && (
        <span className='vs-select-label__main'>
          {mainLabel}
        </span>
      )}

      {subLabel && (
        <span className='vs-select-label__sub'>
          { subLabel }
        </span>
      )}
    </components.SingleValue>
  )
}

export default TwoPartLabel
